// ** Third Party Components
import {Edit} from 'react-feather'

// ** Table Common Column
export const columns = (toggleModal) => [
  {
    name: 'Id Sociedad',
    width: '20%',
    center: true,
    selector: row => row.id,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.id}
      </div>
    )
  },
  {
    name: 'Nombre',
    width: '30%',
    sortable: true,
    center: true,
    selector: row => row.name
  },
  {
    name: 'Id de Tax',
    width: '20%',
    sortable: true,
    center: true,
    selector: row => row.taxId
  },
  {
    name: 'Status',
    width: '20%',
    sortable: true,
    center: true,
    selector: row => row.status
  },
  {
    name: 'Acciones',
    width: '10%',
    center: true,
    allowOverflow: true,
    cell: (row) => {
      return (
        <div className='d-flex'>
          <div className='cursor-pointer text-primary'>
            <Edit onClick={() => toggleModal(true, row)} size={20} />
          </div>
          {/*<div className='ps-1 cursor-pointer'>
              <Trash size={20} />
          </div>*/}
        </div>
      )
    }
  }
]
